type Func<T extends any[], R> = (...args: T) => R;

const debounce = <F extends Func<any[], any>>(func: F, delay?: number) => {
  let timeoutId: ReturnType<typeof setTimeout>;

  return (...args: Parameters<F>) => {
    clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      // eslint-disable-next-line prefer-spread
      func.apply(null, args);
    }, delay || 500);

    return timeoutId;
  };
};

export default debounce;
